package it.neckar.lizergy.model.customer

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 * The address
 */
@JsExport
@Serializable
data class Address(
  val street: String,
  val houseNumber: String,
  val zipCode: String,
  val city: String,
  /**
   * The country
   */
  val country: String = "Germany",
) {

  /**
   * Returns true if all properties are set
   */
  val isPlausible: Boolean
    get() = street.isNotBlank()
      && houseNumber.isNotBlank()
      && zipCode.isNotBlank()
      && city.isNotBlank()
      && country.isNotBlank()

  /**
   * Returns the street with house number
   */
  val streetWithHouseNumber: String
    get() = "$street $houseNumber"

  val cityWithZipCode: String
    get() = "$zipCode $city"

  /**
   * Returns the address as single line (without the country)
   */
  fun singleLine(): String {
    return "$street $houseNumber, $zipCode $city".trim(' ', ',')
  }

  /**
   * Returns true if all elements are empty
   */
  fun isEmpty(): Boolean {
    return street.isEmpty() && houseNumber.isEmpty() && zipCode.isEmpty() && city.isEmpty()
  }

  companion object {
    /**
     * Represents an empty address in Germany
     */
    val empty: Address = Address("", "", "", "", "Germany")
  }
}
